import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Layouts
import { LayoutDashboardComponent } from './layout/layout-dashboard/layout-dashboard.component';
import { LayoutHomeComponent } from './layout/layout-home/layout-home.component';
import { LayoutCommunityComponent } from './layout/layout-community/layout-community.component';

export const routes: Routes = [{
  path: '',
  redirectTo: 'auth',
  pathMatch: 'full',
},
{
  path: 'admin',
  redirectTo: 'communities',
  pathMatch: 'full',
},
{
  path: '',
  component: LayoutDashboardComponent,
  data: {
    title: ''
  },
  children: [
    {
      path: 'dashboard',
      loadChildren: './dashboard/dashboard.module#DashboardModule'
    },
    {
      path: 'category',
      loadChildren: './category/category.module#CategoryModule'
    },
    {
      path: 'units',
      loadChildren: './conformation-of-the-community/units/units.module#UnitsModule'
    },
    {
      path: 'home-community',
      loadChildren: './conformation-of-the-community/home/home.module#HomeModule'
    },
    {
      path: 'fund',
      loadChildren: './accountant/maintainers/fund/fund.module#FundModule'
    },
    {
      path: 'sector',
      loadChildren: './conformation-of-the-community/sectors/sectors.module#SectorsModule'
    },
    {
      path: 'property',
      loadChildren: './conformation-of-the-community/property/property.module#PropertyModule'
    },
    {
      path: 'initial-balance',
      loadChildren: './conformation-of-the-community/initial-balance/initial-balance.module#InitialBalanceModule'
    },
    {
      path: 'not-operational-income',
      loadChildren: './incomes/not-operational/not-operational.module#NotOperationalModule',
    },
    {
      path: 'community-settings',
      loadChildren: './conformation-of-the-community/community-settings/community-settings.module#CommunitySettingsModule'
    },
    {
      path: 'import-community',
      loadChildren: './conformation-of-the-community/import-community/import-community.module#ImportCommunityModule'
    },
    {
      path: 'bank-account',
      loadChildren: './accountant/maintainers/bank-account/bank-account.module#BankAccountModule'
    },
    {
      path: 'checkbooks',
      loadChildren: './accountant/maintainers/checkbooks/checkbooks.module#CheckbooksModule'
    },
    {
      path: 'expense-account',
      loadChildren: './accountant/maintainers/expense-account/expense-account.module#ExpenseAccountModule'
    },
    {
      path: 'transfer',
      loadChildren: './accountant/maintainers/transfer/transfer.module#TransferModule',
    },
    {
      path: 'accountant',
      data: {
        title: ''
      },
      children: [
        {
          path: 'fund-surrender',
          loadChildren: './accountant/fund-surrender/fund-surrender.module#FundSurrenderModule',
          data: {
            title: ''
          },
        },
      ]
    },
    {
      path: 'fund-balance',
      loadChildren: './accountant/report/fund-balance/fund-balance.module#FundBalanceModule',
    },
    {
      path: 'list-checks',
      loadChildren: './accountant/report/list-checks/list-checks.module#ListChecksModule',
    },
    {
      path: 'transaction',
      loadChildren: './accountant/report/transaction/transaction.module#TransactionModule',
    },
    {
      path: 'supplier',
      loadChildren: './common-expense/information-manager/supplier/supplier.module#SupplierModule',
    },
    {
      path: 'interest',
      loadChildren: './common-expense/information-manager/interest/interest.module#InterestModule',
    },
    {
      path: 'fine',
      loadChildren: './common-expense/information-manager/fine/fine.module#FineModule',
    },
    {
      path: 'common-expense-settings',
      loadChildren: './common-expense/information-manager/common-expense-settings/common-expense-settings.module#CommonExpenseSettingsModule',
    },
    {
      path: 'fixed-common-expense',
      loadChildren: './common-expense/information-manager/fixed-common-expense/fixed-common-expense.module#FixedCommonExpenseModule'
    },
    {
      path: 'bank-book',
      loadChildren: './accountant/bank-book/bank-book.module#BankBookModule',
    },
    // {
    //   path: 'operations',
    //   data: {
    //     title: ''
    //   },
    //   children: [
    //     {
    //       path: 'installation',
    //       loadChildren: './operations/installations/installations.module#InstallationsModule',
    //       data: {
    //         title: ''
    //       },
    //     }
    //   ]
    // },
    // {
    //   path: 'budget',
    //   loadChildren: './common-expense/information-manager/budget/budget.module#BudgetModule',
    // },
    {
      path: 'budget-report',
      loadChildren: './common-expense/report/budget-report/budget-report.module#BudgetReportModule',
    },
    {
      path: 'purchase-order',
      loadChildren: './operations/purchase-order/purchase-order.module#PurchaseOrderModule',
    },
    {
      path: 'surcharge',
      loadChildren: './common-expense/create-common-expense/surcharge/surcharge.module#SurchargeModule',
    },
    {
      path: 'expense',
      loadChildren: './common-expense/create-common-expense/expense/expense.module#ExpenseModule',
    },
    {
      path: 'provision',
      loadChildren: './common-expense/create-common-expense/provision/provision.module#ProvisionModule',
    },
    {
      path: 'common-expense',
      loadChildren: './common-expense/report/common-expenses/common-expenses.module#CommonExpensesModule',
    },
    {
      path: 'charge',
      loadChildren: './common-expense/report/charge/charge.module#ChargeModule',
    },
    {
      path: 'operational-payment',
      loadChildren: './incomes/operational/operational.module#OperationalModule',
    },
    {
      path: 'operational-imports',
      loadChildren: './incomes/operational-imports/operational-imports.module#OperationalImportsModule',
    },
    {
      path: 'detail-payments',
      loadChildren: './incomes/detail-payments/detail-payments.module#DetailPaymentsModule',
    },
    {
      path: 'detail-expenses',
      loadChildren: './common-expense/report/detail-expenses/detail-expenses.module#DetailExpensesModule',
    },
    {
      path: 'other-expenses',
      loadChildren: './common-expense/report/other-expenses/other-expenses.module#OtherExpensesModule',
    },
    {
      path: 'consumer-service-report',
      loadChildren: './common-expense/report/consumer-service/consumer-service.module#ConsumerServiceModule',
    },
    {
      path: 'payment-report',
      loadChildren: './common-expense/report/payment-report/payment-report.module#PaymentReportModule',
    },
    {
      path: 'defaulter',
      loadChildren: './common-expense/report/defaulter/defaulter.module#DefaulterModule',
    },
    {
      path: 'interest-report',
      loadChildren: './common-expense/report/interest-report/interest-report.module#InterestReportModule',
    },
    {
      path: 'defaulter-property',
      loadChildren: './common-expense/report/defaulter-property/defaulter-property.module#DefaulterPropertyModule',
    },
    {
      path: 'proportionality',
      loadChildren: './common-expense/report/proportionality/proportionality.module#ProportionalityModule',
    },
    {
      path: 'finantial-state',
      loadChildren: './accountant/report/finantial-state/finantial-state.module#FinantialStateModule',
    },
    // {
    //   path: 'maintenance',
    //   loadChildren: './operations/maintenance/maintenance.module#MaintenanceModule',
    // },
    {
      path: 'outcome',
      loadChildren: './common-expense/create-common-expense/outcome/outcome.module#OutcomeModule',
    },
    {
      path: 'bills',
      loadChildren: './common-expense/report/bills/bills.module#BillsModule',
    },
    {
      path: 'unidentified-incomes',
      loadChildren: './incomes/unidentified/unidentified.module#UnidentifiedModule',
    },
    {
      path: 'report-outcome',
      loadChildren: './common-expense/report/outcome/outcome.module#OutcomeModule',
    },
    {
      path: 'light-cut',
      loadChildren: './common-expense/report/light-cut/light-cut.module#LightCutModule',
    },
    {
      path: 'conciliation',
      loadChildren: './accountant/conciliation/conciliation.module#ConciliationModule',
    },
    {
      path: 'users',
      loadChildren: './user-config/user.module#UserModule',
    },
    // {
    //   path: 'users-tcel',
    //   loadChildren: './user-config/user-tcel/user-tcel.module#UserTcelModule',
    // },
    {
      path: 'roles',
      loadChildren: './roles/roles.module#RolesModule',
    },
    {
      path: 'visitors',
      loadChildren: './security/visitors/visitors.module#VisitorsModule',
    },
    {
      path: 'permissions',
      loadChildren: './permission/permission.module#PermissionModule',
    },
    {
      path: 'income',
      data: {
        title: ''
      },
      children: [
        {
          path: 'receipt-book',
          loadChildren: './incomes/receipt-book/receipt-book.module#ReceiptBookModule',
          data: {
            title: ''
          },
        }
      ],
    },
    {
      path: 'updated-debt',
      loadChildren: './common-expense/report/updated-debt/updated-debt.module#UpdatedDebtModule',
    },
    {
      path: 'property-balance',
      loadChildren: './common-expense/report/property-balance/property-balance.module#PropertyBalanceModule',
    },
    {
      path: 'consumer-services',
      children: [
        {
          path: 'services',
          loadChildren: './common-expense/information-manager/consumer-services/services/services.module#ServicesModule',
        },
        {
          path: 'distributions',
          loadChildren: './common-expense/information-manager/consumer-services/distributions/distributions.module#DistributionsModule',
        },
        // {
        //   path: 'record-reading',
        //   loadChildren: './common-expense/create-common-expense/record-reading/record-reading.module#RecordReadingModule',
        // },
      ],
    },
    {
      path: 'remunerations',
      loadChildren: './remunerations/remunerations.module#RemunerationsModule'
    },
    {
      path: 'credit-note',
      loadChildren: './incomes/credit-note/credit-note.module#CreditNoteModule'
    },
    {
      path: 'collection-system',
      loadChildren: './common-expense/collection-system/collection-system.module#CollectionSystemModule'
    },
    // {
    //   path: 'citation',
    //   loadChildren: './tcel/citation/citation.module#CitationModule'
    // },
    // {
    //   path: 'provider-status',
    //   loadChildren: './operations/provider-status/provider-status.module#ProviderStatusModule'
    // },
    {
      path: 'announcement',
      loadChildren: './tcel/advertisement/advertisement.module#AdvertisementModule'
    },
    // {
    //   path: 'review',
    //   loadChildren: './operations/review/review.module#ReviewModule'
    // },
    // {
    //   path: 'document-library',
    //   loadChildren: './document-library/document-library.module#DocumentLibraryModule'
    // },
    // {
    //   path: 'register',
    //   loadChildren: './tcel/register/register.module#RegisterModule'
    // }
  ]
},
{
  path: '',
  component: LayoutHomeComponent,
  children: [
    {
      path: 'auth',
      loadChildren: './entry-to-system/entry-to-system.module#EntryToSystemModule',
    }
  ]
},
{
  path: '',
  component: LayoutCommunityComponent,
  children: [
    {
      path: 'communities',
      loadChildren: './conformation-of-the-community/communities/communities.module#CommunitiesModule'
    },
    {
      path: 'users-admin',
      loadChildren: './user-config/user.module#UserModule',
    },
    {
      path: 'profile',
      loadChildren: './profile/profile.module#ProfileModule',
    },
    {
      path: 'roles-admin',
      loadChildren: './roles-admin/roles-admin.module#RolesAdminModule',
    },
    {
      path: 'permissions-admin',
      loadChildren: './permission/permission.module#PermissionModule',
    },
    {
      path: 'administration-setup',
      loadChildren: './configuration-administration/administration/administration.module#AdministrationModule',
    },
    {
      path: 'administration-associate',
      loadChildren: './configuration-administration/associates/administration-associate.module#AdministrationAssociateModule',
    },
    {
      path: 'administration-contact',
      loadChildren: './configuration-administration/contacts/administration-contact.module#AdministrationContactModule',
    }
  ]
}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-router.module.ts